import { updateFormularioPoliticaMunicipalAgriculturaFamiliarByUUID } from 'api/forms/pacote_formularios.api';
import { create } from 'zustand';

export interface IFormPMAF {
  uuid: string
  createdAt: string
  updatedAt: string
  deletedAt: any
  pacote_status: number
  step_atual: number
  institution_uuid: string
  municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena: boolean | null
  tipo_de_instrumento: number | null
  numero_da_publicacao: any | null
  data_da_publicacao: string | null
  upload_documento: string | null
  possui_plano_municipal_agricultura_familiar: boolean | null
  upload_plano_pmaf: string | null
  created_by: string
  updated_by: string
  deleted_by: any
  pacote_formularios_uuid: string
}

interface FormularioPoliticaMunicipalAgriculturaFamiliarStore {
  formulario: IFormPMAF | null;
  setFormulario: (formulario: IFormPMAF | null) => void;
  setPartialForm: (chave: keyof IFormPMAF, valor: any) => void;
  salvarRascunho: () => Promise<boolean>;
  enviarAprovacao: () => Promise<boolean>;
}

export const useFormularioPoliticaMunicipalAgriculturaFamiliarStore =
  create<FormularioPoliticaMunicipalAgriculturaFamiliarStore>((set, get) => ({
    formulario: null,
    setFormulario: (formulario: IFormPMAF | null) => set({ formulario }),
    setPartialForm: (chave: keyof IFormPMAF, valor: any) => {
      set((state) => ({
        formulario: { ...state.formulario!, [chave]: valor },
      }));
    },
    salvarRascunho: async () => {
      const { formulario } = get();
      if (!formulario) return false;

      if (formulario.pacote_status > 3) {
        alert('Formulário já foi enviado para aprovação');
        return false;
      }

      const data = {
        pacote_status: 2, // Status para Rascunho
        municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena:
          formulario.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena,
        tipo_de_instrumento: formulario.tipo_de_instrumento,
        numero_da_publicacao: parseInt(formulario.numero_da_publicacao),
        data_da_publicacao: formulario.data_da_publicacao,
        upload_documento: formulario.upload_documento,
        possui_plano_municipal_agricultura_familiar: formulario.possui_plano_municipal_agricultura_familiar,
        upload_plano_pmaf: formulario.upload_plano_pmaf,
      };

      const response =
        await updateFormularioPoliticaMunicipalAgriculturaFamiliarByUUID(
          formulario.uuid,
          data,
        );

      return response.Status === 'OK';
    },
    enviarAprovacao: async () => {
      const { formulario } = get();
      if (!formulario) return false;

      if (formulario.pacote_status > 3) {
        alert('Formulário já foi enviado para aprovação');
        return false;
      }

      const data = {
        pacote_status: formulario.pacote_status < 3 ? 3 : formulario.pacote_status, // Status para Enviado para Aprovação
        municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena:
          formulario.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena,
        tipo_de_instrumento: formulario.tipo_de_instrumento,
        numero_da_publicacao: parseInt(formulario.numero_da_publicacao),
        data_da_publicacao: formulario.data_da_publicacao,
        upload_documento: formulario.upload_documento,
        possui_plano_municipal_agricultura_familiar: formulario.possui_plano_municipal_agricultura_familiar,
        upload_plano_pmaf: formulario.upload_plano_pmaf,
      };

      const response =
        await updateFormularioPoliticaMunicipalAgriculturaFamiliarByUUID(
          formulario.uuid,
          data,
        );

      return response.Status === 'OK';
    },
  }));
